import { getFunctions, httpsCallable } from 'firebase/functions';

export type PartnerParentDirectory = {
  partnerId: string;
  generatedAt: string;
  students: Array<{
    id: string;
    displayName: string | null;
    parentIds: string[];
    pickupPreference: { options: string[]; otherText?: string } | null;
    photoConsent: 'accept' | 'deny' | null;
  }>;
  parents: Array<{
    id: string;
    displayName: string | null;
    email: string | null;
    phones: string[];
    studentIds: string[];
    status: string | null;
  }>;
};

export async function loadPartnerParentDirectory(partnerId: string): Promise<PartnerParentDirectory> {
  const callable = httpsCallable<{ partnerId: string }, PartnerParentDirectory>(
    getFunctions(),
    'getPartnerParentDirectory'
  );
  const result = await callable({ partnerId });
  return result.data;
}
